import ClubMemberBase from "./club_member_base";


const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubMemberLogItem extends ClubMemberBase {


    @property(cc.RichText)
    content : cc.RichText = null;

    updateInfo(data:any){
        super.updateInfo(data);

        //操作类型 oplog 俱乐部日志查询, 
        // audit_apply 审核, 
        // remove_club_user 移除俱乐部玩家,
        // level_up 成员升级,
        // level_down 成员降级, 
        // balance_charge 货币充值 ,
        // remove_club_admin 移除俱乐部管理员

        let content : string = "";
        if (data.clubOpType == "audit_apply") {            
            content = `${data.nickname}(${data.gameUserId})被<color=#0fffff>${data.opUserName}</color>审核通过,加入俱乐部成功`;
        }
        else if(data.clubOpType == "remove_club_user"){
            content = `${data.nickname}(${data.gameUserId})被<color=#0fffff>${data.opUserName}</color>移除俱乐部`;
        }
        else if(data.clubOpType == "level_up"){
            content = `${data.nickname}(${data.gameUserId})被<color=#0fffff>${data.opUserName}</color>升级为管理员`;
        }
        else if(data.clubOpType == "level_down"){
            content = `<color=#00ff00>${data.nickname}(${data.gameUserId})被<color=#0fffff>${data.opUserName}<color=#00ff00>降级为普通成员</color>`;
        }
        else if(data.clubOpType == "balance_charge"){
            let coins = data.extObj && data.extObj.coins? data.extObj.coins : "";
            content = `${data.nickname}(${data.gameUserId})货币变动<color=#0fffff>${coins}</color>`;
        }
        else if(data.clubOpType == "remove_club_admin"){
            content = `${data.nickname}(${data.gameUserId})被<color=#0fffff>${data.opUserName}</color>移除`;
        }

        this.content.string = content;


    }
  
}
